import React, { useContext } from "react";
import { ModeContext } from "../context/ModeContext";
import Piano from "../components/Piano"; // Adjust path as needed

const Hero = () => {
  const { mode } = useContext(ModeContext);

  return (
    <div
      id="home"
      className={`
    relative w-full flex flex-col items-center px-6 md:px-20 overflow-hidden
    bg-theme-default
  `}
    >
      <div className="flex flex-col text-center mt-2">
        <div className="flex flex-col text-center mt-2 gap-6">
          {/* Main Row: Image + Stats / Bio */}
          <div className="flex flex-col md:flex-row gap-6 max-w-[1200px] mx-auto">
            {/* Left: Image + Stats */}
            <div className="flex flex-col gap-4 md:w-1/3 max-w-[300px] mx-auto md:mx-0">
              <img
                src="../me.jpg"
                alt="Justin Wang"
                className="w-9/10 aspect-square rounded-full object-cover mx-auto
             transition-transform duration-300 ease-in-out transform
             hover:scale-105"
              />

              <div
                className="bg-text-default rounded-xl p-4 w-full flex justify-around text-center gap-4
                transition-transform duration-300 ease-in-out transform
                hover:scale-105"
              >
                <div>
                  <span className="font-bold text-lg transition-transform duration-300 ease-in-out transform hover:scale-105">
                    3.98
                  </span>
                  <p className="text-sm text-color-sub transition-transform duration-300 ease-in-out transform hover:scale-105">
                    GPA
                  </p>
                </div>
                <div>
                  <span className="font-bold text-lg transition-transform duration-300 ease-in-out transform hover:scale-105">
                    CS & Music
                  </span>
                  <p className="text-sm text-color-sub transition-transform duration-300 ease-in-out transform hover:scale-105">
                    Majors
                  </p>
                </div>
                <div>
                  <span className="font-bold text-lg transition-transform duration-300 ease-in-out transform hover:scale-105">
                    May '27
                  </span>
                  <p className="text-sm text-color-sub transition-transform duration-300 ease-in-out transform hover:scale-105">
                    Graduation
                  </p>
                </div>
              </div>
            </div>

            {/* Right: Name + description */}
            <div className="bg-text-default rounded-xl p-6 flex-1 text-center md:text-left flex flex-col justify-between">
              <div>
                <h1 className="text-4xl md:text-6xl font-heading font-extrabold mb-2 tracking-tight">
                  Justin Wang
                </h1>
                <p className="text-gray-700 text-lg md:text-xl">
                  Software Engineer
                </p>
                <p className="mt-4">
                  Hi, my name is Justin Wang - I'm a 4th year Computer Science
                  and Music major at the University of Florida. Whether its
                  writing software for web applications or embedded systems, I
                  am passionate about making a difference. I'm currently
                  interested in newgrad Software Engineering positions after my
                  expected graduation date of May 2027. Please don't hesitate to
                  reach out!
                </p>
              </div>
              {/* Socials box */}
              <div className="bg-yellow-100 rounded-xl p-4 mt-4 flex flex-wrap gap-4 justify-center md:justify-start items-center">
                {/* Row 1: LinkedIn, GitHub, Resume */}
                <div className="flex flex-wrap gap-4 w-full lg:w-auto justify-center lg:justify-start">
                  {/* LinkedIn */}
                  <a
                    href="https://www.linkedin.com/in/justinwang05"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 hover:text-blue-600 transition-colors
             transition-transform duration-300 ease-in-out transform hover:scale-105"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM0 8h5v16H0V8zm7.5 0h4.75v2.25h.07c.66-1.25 2.28-2.57 4.7-2.57 5.03 0 5.95 3.3 5.95 7.58V24h-5V15.5c0-2.03-.04-4.64-2.83-4.64-2.84 0-3.27 2.22-3.27 4.5V24h-5V8z" />
                    </svg>
                    LinkedIn
                  </a>

                  {/* GitHub */}
                  <a
                    href="https://github.com/justinwang05"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 hover:text-blue-600 transition-colors
             transition-transform duration-300 ease-in-out transform hover:scale-105"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M12 0C5.37 0 0 5.37 0 12c0 5.3 3.438 9.8 8.205 11.385.6.113.82-.262.82-.583 0-.288-.01-1.05-.015-2.06-3.338.724-4.042-1.61-4.042-1.61-.546-1.385-1.333-1.753-1.333-1.753-1.09-.746.082-.73.082-.73 1.205.085 1.84 1.236 1.84 1.236 1.07 1.832 2.807 1.303 3.492.996.108-.776.418-1.303.76-1.603-2.665-.304-5.466-1.333-5.466-5.933 0-1.31.47-2.38 1.236-3.22-.124-.304-.536-1.523.116-3.176 0 0 1.008-.323 3.3 1.23a11.45 11.45 0 013.003-.403 11.47 11.47 0 013.003.403c2.29-1.553 3.296-1.23 3.296-1.23.654 1.653.242 2.872.118 3.176.77.84 1.234 1.91 1.234 3.22 0 4.61-2.804 5.625-5.475 5.922.43.372.814 1.102.814 2.222 0 1.606-.015 2.902-.015 3.293 0 .322.216.697.825.58C20.565 21.796 24 17.296 24 12c0-6.63-5.373-12-12-12z" />
                    </svg>
                    GitHub
                  </a>

                  {/* Resume */}
                  <a
                    href="/Justin_Wang_Resume.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 hover:text-blue-600 transition-colors
             transition-transform duration-300 ease-in-out transform hover:scale-105"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M6 2h9l5 5v15a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2zM14 3v4h4M8 11h8M8 15h8M8 19h5" />
                    </svg>
                    Resume
                  </a>
                </div>

                {/* Row 2: Phone & Email */}
                <div className="flex items-center gap-2">
                  {/* Phone */}
                  <div
                    className="flex items-center gap-2 hover:text-blue-600 transition-colors
             transition-transform duration-300 ease-in-out transform hover:scale-105"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.21c1.2.48 2.52.74 3.87.74a1 1 0 011 1v3.5a1 1 0 01-1 1C10.07 21 3 13.93 3 5.5a1 1 0 011-1h3.5a1 1 0 011 1c0 1.35.26 2.67.74 3.87a1 1 0 01-.21 1.11l-2.2 2.21z" />
                    </svg>
                    <span>+1 (239) 315 5050</span>
                  </div>

                  {/* Email */}
                  <a
                    href="mailto:justinw2608@gmail.com"
                    className="flex items-center gap-2 hover:text-blue-600 transition-colors
                    transition-transform duration-300 ease-in-out transform hover:scale-105"
                  >
                    <svg
                      className="w-6 h-6"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                    </svg>
                    <span>justinw2608@gmail.com</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p className="text-m md:text-m text-color-sub mb-2 mt-4">
          To navigate the page, select a Destination and play its theme on the
          piano.
          <br />
          <em>... alternatively, you can just keep scrolling.</em>
        </p>
      </div>

      {/* Piano section */}
      <div className="w-full max-w-5xl flex flex-col items-center">
        <Piano />
      </div>
    </div>
  );
};

export default Hero;
